import { Grid, Paper, Typography } from '@mui/material';

export const ThirdPolicy = () => {
    return (
        <Paper square sx={{ backgroundColor: '#1976d2', margin: 1 }}>
            <Grid container direction="column" px={2} pb={2} spacing={2}>
                <Grid item container justifyContent="center">
                    <Typography variant="h6" color="white">
                        1人1人のレベルに合った指導
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="body2" color="white">
                        運動が苦手、まずは体力作りをしたい子も、もちろん野球を上手くなりたい子も歓迎
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    )
}